/* eslint-disable prettier/prettier */
import styled from 'styled-components';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Checkbox from '@material-ui/core/Checkbox';

import {
    X,
    VideoBackGround,
    Rectangle13,
    Rectangleandgreychek,
    CheckboxActive,
} from '../../Constants/assets';
// Stylings

const InnerContainer = styled.div`
  width: 500px;
  height: 338px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  position: fixed;
  font-family: "Roboto", sans-serif;
  z-index: 99999; // more then the pause block element
  animation: zoomIn 0.2s ease-in-out;
  padding: 35px 30px;
  `;
const TextContainer = styled.div`
height: max-content;
margin-bottom: 15px;
`;
const XContainer = styled(X)``;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 22%;
`;
const HeaderText = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 90%;
  color: ${(props) => props.theme.colors.black};
  height: 95%;
`;
const ParagraphText = styled.div`
  font-size: 16px;
  margin-top: 15px;
  line-height: 135%;
  color: ${(props) => props.theme.colors.black};
  display: inline-table;
`;

const ButtonContainer = styled.button`
  width: 216px;
  height: 50px;
  background: ${(props) => props.theme.colors.darkGreen};
  border-radius: 4px;
  cursor: pointer;
  border: none;
`;
const ButtonContainerLine = styled.div`
  height: 45%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;
const GetStartedButton = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 2.05vh;
  color: ${(props) => props.theme.colors.white};
  width: 100%;
`;
const DontShowContainer = styled.div`
  height: 13%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const DontShowText = styled.div``;
const CardCheckbox = styled(Checkbox)`
  /* && {
        position: absolute;
        right: 0;
    } */
  && {
    height: 44px;
  }
`;

// TODO: Fix this, this is temporary fix
export default function AfterMilestonePopUp({
    show,
    toggleAfterMilestonePopUp,
    playerStatus,
    player,
    walkingAlgorithm,
    toggleMilestonCkeckbox,
    afterMilestonChecked,
}) {
    const [keepShowingPopUp, setKeepShowingPopUp] = useState(true);
    const [afterCheckboxChecked, setafterCheckboxChecked] = useState(false);
    const { t } = useTranslation();
    if (show && keepShowingPopUp) {
        return (
            <InnerContainer>
                <TextContainer>
                    <HeaderContainer>
                        <HeaderText>{t('modals.general_tasks.info_title')}</HeaderText>
                        <XContainer
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                if (afterCheckboxChecked) {
                                    setKeepShowingPopUp(false);
                                    toggleAfterMilestonePopUp(false);
                                }
                                if (!afterCheckboxChecked) {
                                    toggleAfterMilestonePopUp(false);
                                }
                            }}
                        />
                    </HeaderContainer>
                    <ParagraphText style={{ textAlign: 'left' }}>
                        {t('modals.general_tasks.info_text')}
                    </ParagraphText>
                </TextContainer>
                <DontShowContainer>
                        <CardCheckbox
                            onChange={() => setafterCheckboxChecked(!afterCheckboxChecked)}
                            icon={
                                <Rectangle13
                                    style={{
                                        width: '24px',
                                        height: '24px',
                                        transform: 'scale(0.9)',
                                    }}
                                />
                            }
                            checkedIcon={
                                <CheckboxActive style={{ width: '24px', height: '24px' }} />
                            }
                        />
                        <DontShowText>{t('modals.general_tasks.checkbox')}</DontShowText>
                    </DontShowContainer>
                <ButtonContainerLine>
                    <ButtonContainer
                        onClick={() => {
                            if (afterCheckboxChecked) {
                                setKeepShowingPopUp(false);
                                toggleAfterMilestonePopUp(false);
                            }
                            if (!afterCheckboxChecked) {
                                toggleAfterMilestonePopUp(false);
                            }
                        }}
                    >
                        <GetStartedButton>{t('modals.general_tasks.button1')}</GetStartedButton>
                    </ButtonContainer>
                </ButtonContainerLine>
            </InnerContainer>
        );
    }
    return null;
}
